import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.title',
    defaultMessage: 'Plan your project with Voice Request™',
  },
  subtitle: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.subtitle',
    defaultMessage:
      'Your project deadline is crucial, so knowing an ETA on your project is key. Use our Voice Request™ feature to instantly prompt your selected voices for an expected deadline and for a sample to compare their voices.',
  },
  inProgress: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.inProgress',
    defaultMessage:
      'The selected voices have received a push notification from Voice Request™ to record and respond with an expected deadline.',
  },
  eta: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.eta',
    defaultMessage: 'Recorded {relativeTime} ({absoluteTime})',
  },
  waiting: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.waiting',
    defaultMessage: 'Waiting',
  },
  select: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.buttons.select',
    defaultMessage: 'Select',
  },
  request: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.buttons.request',
    defaultMessage: 'Request',
  },
  loading: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.buttons.loading',
    defaultMessage: 'Dispatching',
  },
  pause: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.buttons.pause',
    defaultMessage: 'Pause',
  },
  play: {
    id: 'containers.ProjectPage.components.ProjectVoiceBook.buttons.play',
    defaultMessage: 'Play',
  },
})
